// region Imports
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Translate } from "react-redux-i18n";
import Utilities from "../../Helpers/Utilities";
// endregion

// region Styles
const FlexRow = styled.div`
    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) {
        margin-top: -20px;
    }

    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 992px) {
        display: flex;
    }
`;

const SummaryBoxContainer = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        &.col-lg-6:not(:last-child) {
            margin-bottom: 20px
        }
    }
`;

const FlexSummaryBoxContainer = styled(SummaryBoxContainer)`
    ${FlexRow} &:not(:last-child) {
        // Extra large devices (large desktops, 1200px and up)
        @media (min-width: 992px) {
            flex: 1;
        }
    }

    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        &:not(:last-child) {
            margin-bottom: 20px
        }
    }
`;

const Box = styled.div`
    .col-lg-6 &:not(:last-of-type) {
        margin-bottom: 0;
    }
    
    // Medium devices (tablets, less than 992px)
    @media (max-width: 991.98px) {
        .col-12 & {
            margin-top: 20px;
        }
    }
  
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        .col-lg-6 & {
            margin-bottom: 0;
            height: 100%;
        }
    }
`;

const BoxedColumn = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        .checkout-summary & {
            margin-bottom: 0;
            padding: 0 15px !important;
        }
    }
`;
// endregion

function CheckoutSummary(props) {
    const {
        subTotal,
        shippingOption,
        shipping,
        taxes,
        total,
        recurringTotal,
        leaseAmount,
        credCardCharge,
        isCredCharge
    } = props;

    return (
        <div className="container">
            <div className="row justify-content-center checkout-summary">
                <div className="col-md-10">
                    <FlexRow className="row">
                        <FlexSummaryBoxContainer className="col-lg-6">
                            <Box className="boxed boxed--border cart-total" style={{ marginTop: 0 }}>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5"><Translate value="checkout.summary.payInFull.subTotal" />:</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-4 text-right">
                                        <span>{Utilities.formatPrice(subTotal)}</span>
                                    </BoxedColumn>
                                </div>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5">{shippingOption}</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-4 text-right">
                                        <span>{Utilities.formatPrice(shipping)}</span>
                                    </BoxedColumn>
                                </div>
                                <div className="row">
                                    <BoxedColumn className="col-6">
                                        <span className="h5"><Translate value="checkout.summary.payInFull.taxes" />:</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-6 text-right">
                                        <span><Translate value="checkout.summary.payInFull.taxStatement" /></span>
                                    </BoxedColumn>
                                </div>
                                {isCredCharge &&
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5"><Translate value="checkout.summary.payInFull.fee" />:</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-4 text-right">
                                        <span>{Utilities.formatPrice(credCardCharge)}</span>
                                    </BoxedColumn>
                                </div>
                                }
                                <hr/>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5"><Translate value="checkout.summary.payInFull.total" />:</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-4 text-right">
                                        <span className="h5">{Utilities.formatPrice(total)}</span>
                                    </BoxedColumn>
                                </div>
                            </Box>
                        </FlexSummaryBoxContainer>
                        <FlexSummaryBoxContainer className="col-lg-6">
                            <Box className="boxed boxed--border cart-total" style={{ marginTop: 0 }}>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5"><Translate value="checkout.summary.recurring.subTotal" />:</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-4 text-right">
                                        <span>{Utilities.formatPrice(recurringTotal)}</span>
                                    </BoxedColumn>
                                </div>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5" style={{ color: "#fff" }}>Taxes</span>
                                    </BoxedColumn>
                                </div>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5" style={{ color: "#fff" }}>Shipping</span>
                                    </BoxedColumn>
                                </div>
                                <hr/>
                                <div className="row">
                                    <BoxedColumn className="col-8">
                                        <span className="h5"><Translate value="checkout.summary.recurring.total" />:</span>
                                    </BoxedColumn>
                                    <BoxedColumn className="col-4 text-right">
                                        <span className="h5">{Utilities.formatPrice(recurringTotal)}</span>
                                    </BoxedColumn>
                                </div>
                            </Box>
                        </FlexSummaryBoxContainer>
                    </FlexRow>
                    {leaseAmount &&
                    <div className="row" style={{ marginTop: 20 }}>
                        <div className="col-12">
                            <div className="boxed boxed--border cart-total" style={{ marginTop: 0 }}>
                                <div className="row">
                                    <BoxedColumn className="col-12">
                                        <span className="h5 text-center"><Translate value="checkout.summary.lease.message" />: {Utilities.formatPrice(leaseAmount)}</span>
                                    </BoxedColumn>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    );
}

CheckoutSummary.propTypes = {
    subTotal: PropTypes.number,
    shippingOption: PropTypes.string,
    shipping: PropTypes.number,
    taxes: PropTypes.number,
    total: PropTypes.number,
    recurringTotal: PropTypes.number,
    leaseAmount: PropTypes.number
};

export default CheckoutSummary;